import { Http } from '@/lib/http';

export class OnboarderDoucmentSettingsService extends Http {
  endpoint = 'onboarder/settings/onboarding-documents';

  constructor() {
    super();
  }

  fetchOnboardingDocuments() {
    return this.httpClient().get(this.endpoint);
  }

  createOnboardingDocuments(document) {
    return this.httpClient().post(this.endpoint, document);
  }

  updateOnboardingDocuments(id, updatedDocument) {
    return this.httpClient().patch(`${this.endpoint}/${id}`, updatedDocument);
  }
}
